var parent = require('../stable/is-iterable');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/is-iterable.js
// module id = 591
// module chunks = 0 1